import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo } from "react";

import colors from "app/colors";
import { DrawIcon } from "modules/icons";
import { FileFragment, MessageThreadFragment } from "gql/graphql";
import useEditImage from "modules/hooks/use-edit-image";
import {
  isImage,
  isMessageThreadReadOnlyAndIsReader,
} from "modules/utils/Functions";
import { useAuth } from "modules/providers/auth-provider";

interface IProps {
  messageThread: MessageThreadFragment;
  file: FileFragment;
  draftId: string;
}

const MessagePopoverEditImageButton: React.FC<IProps> = ({
  messageThread,
  file,
  draftId,
}) => {
  const { me } = useAuth();
  const { openEditImageModal } = useEditImage({ file, draftId });

  if (!isImage(file.contentType)) return null;

  if (!me) return null;

  if (isMessageThreadReadOnlyAndIsReader(messageThread, me)) {
    return null;
  }

  return (
    <Button variant="link" onClick={openEditImageModal}>
      <HStack spacing={3}>
        <DrawIcon boxSize={5} fill={colors.blue} />
        <Text fontSize={14} color={colors.blackSecondary}>
          Draw
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessagePopoverEditImageButton);
